export default __webpack_public_path__ + "static/media/1631.1f917a65.png";